import React from "react";
import AIAcademyContent from "../function-components/AIAcademyFolder/AIAcademyContent";

function AIAcademy() {
  return (
    <>
      <AIAcademyContent />
    </>
  );
}

export default AIAcademy;
